import { basicTheme } from '../theme';
import { engagementAnalyticsColor } from './color';
export const EngagementAnalyticsTheme = { ...basicTheme,
  COLORS_BASIC: engagementAnalyticsColor.COLORS_BASIC,
  COLORS: engagementAnalyticsColor.COLORS,
  colors: engagementAnalyticsColor.colors
};